/** @namespace System */
NS("System");

/**
 * @class
 */
System.Command = Class( /** @lends System.Command.prototype */ {
    /**
     * @type {Object}
     */
    options: null,
    /**
     * @param {Object|Function} [options]
     */
    initialize(options) {
        if (_.isFunction(options)) {
            options = {
                run: options.run
            };
        }

        this.options = options || {};
    },
    /**
     * Run the Command
     */
    run() {
        Util.call(this.options.run, this);
    },
    /**
     * Undo Command
     */
    undo() {
        Util.call(this.options.undo, this);
    }
});
